<template>
  <el-container class="app-wrapper">
    <el-header class="header" height="60px">
      <nav-bar />
    </el-header>
    <el-container class="main-container">
      <el-aside width="220px" class="aside">
        <side-bar class="sidebar-container" :userScore="userScore" />
      </el-aside>
      <el-main class="content publicScroll">
        <app-main />
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import { NavBar, SideBar, AppMain } from "./components";
import { SWNEWS_HOST } from "../../constants/apiHosts";

export default {
  name: "Layout",
  components: {
    NavBar,
    SideBar,
    AppMain,
  },
  data() {
    return {
      userScore: {},
    };
  },
  created() {
    this.getUserScore();
  },
  methods: {
    getUserScore() {
      this.$axios
        .get(`${SWNEWS_HOST}/api/creatorScore/getUserScore`, {})
        .then((res) => {
          if (res.data.code == 0) {
            this.userScore = res.data.data;
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.app-wrapper {
  background: #f7f8f9;

  .header {
    padding: 0 10px;
    display: flex;
    justify-content: center;
    background: #fff;
  }
  .main-container {
    max-width: 1520px;
    width: 100%;
    margin: 20px auto;
    display: flex;

    .aside {
      width: 220px;
      margin-right: 20px;
      border-radius: 10px;
    }
    .content {
      flex: 1;
      padding: 0;
      border-radius: 8px;
      height: calc(100vh - 100px);
      overflow: auto;
    }
  }
}
</style>
